module.exports = __webpack_public_path__ + "2ab3d86678e61d0dc9580e28a4f0d4ba.png";